import React, { useState } from 'react';
import { BarChart3Icon, HeadsetIcon, SparklesIcon, XIcon } from 'lucide-react';
import { dashboardImages } from '../../data/dashboardVisual';
const BENEFITS = [{
  icon: HeadsetIcon,
  label: 'Priority support'
}, {
  icon: BarChart3Icon,
  label: 'Advanced analytics'
}, {
  icon: SparklesIcon,
  label: 'Exclusive perks'
}];

/**
 * Campuzon Plus. The banner is deliberate about its own status: nothing is on
 * sale yet, so both actions explain that rather than opening a checkout that
 * cannot complete.
 */
export function PremiumBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [detail, setDetail] = useState<'upgrade' | 'learn' | null>(null);
  if (dismissed) return null;
  return <section id="campuzon-plus" aria-labelledby="plus-heading" className="relative overflow-hidden rounded-panel bg-brand-900 px-5 py-6 sm:px-7" data-id="element-1067" data-mp="19i0pgf6dlxr0">
      <img src={dashboardImages.crown} alt="" loading="lazy" className="pointer-events-none absolute -right-2 bottom-0 hidden h-32 w-32 object-contain mix-blend-lighten lg:block" data-id="element-1068" data-mp="10fhqw79mi7ak" />

      <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss Campuzon Plus" className="absolute right-2 top-2 flex h-11 w-11 items-center justify-center rounded-full text-brand-100 transition-colors duration-150 ease-out hover:bg-white/10 hover:text-white" data-id="element-1069" data-mp="2sf2rsbco9d26">
        <XIcon aria-hidden className="h-5 w-5" data-id="element-1070" data-mp="36ebwoevfgkqu" />
      </button>

      <div className="relative flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between lg:pr-40" data-id="element-1071" data-mp="3bd5cwf23mpup">
        <div className="max-w-[34rem]" data-id="element-1072" data-mp="2xc2ohvnmt3gm">
          <h2 id="plus-heading" className="text-h4 font-semibold text-white" data-id="element-1073" data-mp="2xf6y58jv8reo">
            Achieve more with Campuzon Plus
          </h2>
          <p className="mt-1.5 text-body-sm leading-6 text-brand-100" data-id="element-1074" data-mp="1lxfpg9chsley">
            Priority support, advanced analytics and exclusive student benefits.
          </p>

          <div className="mt-4 flex flex-wrap gap-2.5" data-id="element-1075" data-mp="1px7o9uc33d74">
            <button type="button" onClick={() => setDetail(detail === 'upgrade' ? null : 'upgrade')} aria-expanded={detail === 'upgrade'} className="inline-flex min-h-touch items-center gap-2 rounded-lg bg-brand-500 px-4 text-body-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-600" data-id="element-1076" data-mp="3sl6caaw3uys1">
              <SparklesIcon aria-hidden className="h-4 w-4" data-id="element-1077" data-mp="39vzwavmp4l9x" />
              Upgrade now
            </button>
            <button type="button" onClick={() => setDetail(detail === 'learn' ? null : 'learn')} aria-expanded={detail === 'learn'} className="inline-flex min-h-touch items-center rounded-lg border border-white/30 px-4 text-body-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-white/10" data-id="element-1078" data-mp="34vls5oo7tvh6">
              Learn more
            </button>
          </div>

          {detail && <p className="mt-3.5 max-w-[46ch] rounded-lg bg-white/10 px-3.5 py-3 text-caption leading-5 text-brand-50" data-id="element-1079" data-mp="11omp9dfz465a">
              {detail === 'upgrade' ? 'Campuzon Plus is not on sale yet. Nothing is charged today, and no payment method is collected — subscription billing is waiting on the licensed payment provider.' : 'Plus is being prepared. When it opens, what it includes and what it costs will be published in full before anyone is asked to pay.'}
            </p>}
        </div>

        <ul className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-1080" data-mp="mrlv73ab7z3n">
          {BENEFITS.map(benefit => {
          const Icon = benefit.icon;
          return <li key={benefit.label} className="flex w-24 flex-col items-center gap-1.5 text-center" data-id="element-1081" data-mp="woqlnfb6ugq9">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10" data-id="element-1082" data-mp="235cal66vq9sl">
                  <Icon aria-hidden className="h-5 w-5 text-brand-100" data-id="element-1083" data-mp="283nmdmgqiudg" />
                </span>
                <span className="text-caption font-medium text-brand-100" data-id="element-1084" data-mp="3h0ua0c6yg14t">{benefit.label}</span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}